module.exports = __webpack_public_path__ + "img/border_rectangle2.1f407a31.svg";